import * as Dropdown from "@radix-ui/react-dropdown-menu";
import { useNavigate } from "react-router-dom";
import Kbd from "@/ui/Kbd";
import { isAdmin, useAuth } from "@/lib/auth";
import { useHotkey } from "@/lib/hotkeys";
import { useState } from "react";

const SHORTCUTS: Array<{ keys: string[]; label: string }> = [
  { keys: ["Ctrl", "/"], label: "Abrir este menú de ayuda" },
  { keys: ["/"], label: "Buscar (en la lista de Casos)" },
  { keys: ["Esc"], label: "Cerrar ventana o aviso" },
];

export default function HelpMenu() {
  const nav = useNavigate();
  const user = useAuth((s) => s.user);
  const [open, setOpen] = useState(false);

  useHotkey("ctrl+/", (e) => {
    e.preventDefault();
    setOpen((v) => !v);
  });

  return (
    <Dropdown.Root open={open} onOpenChange={setOpen}>
      <Dropdown.Trigger asChild>
        <button
          aria-label="Ayuda"
          className="inline-flex h-8 w-8 md:h-7 md:w-7 items-center justify-center rounded-full border border-ink-600
                     bg-ink-800 text-xs text-zinc-300 hover:text-accent-400 hover:border-accent-500
                     focus:outline-none focus:ring-2 focus:ring-accent-500"
        >
          ?
        </button>
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content
          align="end"
          sideOffset={8}
          className="z-50 w-72 max-w-[calc(100vw-1.5rem)] rounded-lg border border-ink-700 bg-ink-900 p-3 shadow-2xl
                     data-[state=open]:animate-in data-[state=closed]:animate-out
                     data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
        >
          <div className="text-xs uppercase tracking-wide text-zinc-500 mb-2">
            Atajos
          </div>
          <ul className="space-y-1.5">
            {SHORTCUTS.map((s) => (
              <li key={s.label} className="flex items-center justify-between text-xs">
                <span className="text-zinc-300">{s.label}</span>
                <span className="flex items-center gap-1">
                  {s.keys.map((k, i) => (
                    <span key={i} className="flex items-center gap-1">
                      {i > 0 && <span className="text-zinc-600">+</span>}
                      <Kbd>{k}</Kbd>
                    </span>
                  ))}
                </span>
              </li>
            ))}
          </ul>

          <div className="my-3 h-px bg-ink-700" />

          <Dropdown.Item
            onSelect={() => nav("/ayuda")}
            className="cursor-pointer rounded px-2 py-1.5 text-sm text-zinc-200 outline-none
                       data-[highlighted]:bg-ink-800 data-[highlighted]:text-white"
          >
            Página de ayuda completa
          </Dropdown.Item>
          {isAdmin(user) && (
            <Dropdown.Item
              onSelect={() => window.open("/api/docs", "_blank")}
              className="cursor-pointer rounded px-2 py-1.5 text-sm text-zinc-200 outline-none
                         data-[highlighted]:bg-ink-800 data-[highlighted]:text-white"
            >
              Documentación técnica para desarrolladores
            </Dropdown.Item>
          )}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
}
